'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _angularFix = require('angular-fix');

var _angularFix2 = _interopRequireDefault(_angularFix);

exports['default'] = {
  containsSelector: containsSelector, containsSpecialChar: containsSpecialChar, formlyEval: formlyEval, getFieldId: getFieldId, reverseDeepMerge: reverseDeepMerge, findByNodeName: findByNodeName,
  arrayify: arrayify, extendFunction: extendFunction, extendArray: extendArray, startsWith: startsWith, contains: contains
};

function containsSelector(string) {
  return containsSpecialChar(string, '.') || containsSpecialChar(string, '[') && containsSpecialChar(string, ']');
}

function containsSpecialChar(a, b) {
  if (!a || !a.indexOf) {
    return false;
  }
  return a.indexOf(b) !== -1;
}

function formlyEval(scope, expression, $modelValue, $viewValue, extraLocals) {
  if (_angularFix2['default'].isFunction(expression)) {
    return expression($viewValue, $modelValue, scope, extraLocals);
  } else {
    return scope.$eval(expression, _angularFix2['default'].extend({ $viewValue: $viewValue, $modelValue: $modelValue }, extraLocals));
  }
}

function getFieldId(formId, options, index) {
  if (options.id) {
    return options.id;
  }
  var type = options.type;
  if (!type && options.template) {
    type = 'template';
  } else if (!type && options.templateUrl) {
    type = 'templateUrl';
  }

  return [formId, type, options.key, index].join('_');
}

function reverseDeepMerge(dest) {
  _angularFix2['default'].forEach(arguments, function (src, index) {
    if (!index) {
      return;
    }
    _angularFix2['default'].forEach(src, function (val, prop) {
      if (!_angularFix2['default'].isDefined(dest[prop])) {
        dest[prop] = _angularFix2['default'].copy(val);
      } else if (objAndSameType(dest[prop], val)) {
        reverseDeepMerge(dest[prop], val);
      }
    });
  });
  return dest;
}

function objAndSameType(obj1, obj2) {
  return _angularFix2['default'].isObject(obj1) && _angularFix2['default'].isObject(obj2) && Object.getPrototypeOf(obj1) === Object.getPrototypeOf(obj2);
}

// recurse down a node tree to find a node with matching nodeName, for custom tags jQuery.find doesn't work in IE8
function findByNodeName(el, nodeName) {
  if (!el.prop) {
    // not a jQuery or jqLite object -> wrap it
    el = _angularFix2['default'].element(el);
  }

  if (el.prop('nodeName') === nodeName.toUpperCase()) {
    return el;
  }

  var c = el.children();
  for (var i = 0; c && i < c.length; i++) {
    var node = findByNodeName(c[i], nodeName);
    if (node) {
      return node;
    }
  }
}

function arrayify(obj) {
  if (obj && !_angularFix2['default'].isArray(obj)) {
    obj = [obj];
  } else if (!obj) {
    obj = [];
  }
  return obj;
}

function extendFunction() {
  for (var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function extendedFunction() {
    var args = arguments;
    fns.forEach(function (fn) {
      return fn.apply(null, args);
    });
  };
}

function extendArray(primary, secondary, property) {
  if (property) {
    primary = primary[property];
    secondary = secondary[property];
  }
  if (secondary && primary) {
    _angularFix2['default'].forEach(secondary, function (item) {
      if (primary.indexOf(item) === -1) {
        primary.push(item);
      }
    });
    return primary;
  } else if (secondary) {
    return secondary;
  } else {
    return primary;
  }
}

function startsWith(str, search) {
  if (_angularFix2['default'].isString(str) && _angularFix2['default'].isString(search)) {
    return str.length >= search.length && str.substring(0, search.length) === search;
  } else {
    return false;
  }
}

function contains(str, search) {
  if (_angularFix2['default'].isString(str) && _angularFix2['default'].isString(search)) {
    return str.length >= search.length && str.indexOf(search) !== -1;
  } else {
    return false;
  }
}
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./other/utils.js
 **/